export const DOWNLOAD_ENTRY_KINDS = {
    FILE: 'file',
    FOLDER: 'folder',
};
export const DOWNLOAD_START_FAILURE_STAGES = {
    DOWNLOAD_START: 'download start',
    FILESPACE_LOGIN: 'filespace login',
    SERVICE_WORKER_REGISTRATION: 'service worker registration',
};
export const DOWNLOAD_FAILURE_REASONS = {
    BROWSER_CANCELLED: 'browser cancelled',
    END_FAILED: 'end failed',
    READ_FAILED: 'read failed',
    SEND_FAILED: 'send failed',
    WORKER_TERMINATED: 'worker terminated',
    WORKER_UNRESPONSIVE: 'worker unresponsive',
};
